import { any, func } from 'prop-types'
import Input from '@taglivros/oef_componentes/build/components/input'
import React from 'react'
import { formatCEP } from '../../utils/formatter/formatter'
import { sanitizeValue } from '../../utils/helpers/helpers'

const CEPInput = ( { value, onChange, ...props } ) => {
  const handleChange = ( event ) => {
    if ( onChange ) {
      onChange( {
        'target': {
          'name': event.target.name,
          'value': sanitizeValue( event.target.value )
        }
      } )
    }
  }

  return (
    <Input
      { ...props }
      onChange={ handleChange }
      value={ formatCEP( value ) }
    />
  )
}

CEPInput.propTypes = {
  'onChange': func.isRequired,
  'value': any
}

CEPInput.defaultProps = {
  'value': ''
}

export default CEPInput

